
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller-guide",
      function () {
        return require("private-next-pages/seller-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seller-guide"])
      });
    }
  